import * as XLSX from "xlsx";
import moment from "moment";
import { getInmobiliaria } from "../getInmobiliaria";

const clasificarRenta = (r) => {
  const hoy = moment().startOf("day");
  const month = String(r?.month || "");
  const startStr = month.split(" - ")[0]?.trim();
  const start = startStr ? moment(startStr, "YYYY-MM-DD", true) : null;

  if (r?.status === true) return "COBRADA";
  if (start?.isValid() && start.isSameOrBefore(hoy, "day")) return "ATRASADA";
  if (start?.isValid() && start.isAfter(hoy, "day")) return "PROGRAMADA";
  return "SIN_CLASIFICAR";
};

const buildInmuebleNameLookup = (inmuebles = []) => {
  const map = {};
  for (const i of inmuebles) {
    const nombre = i?.name || i?.title || `Inmueble #${i?.id ?? "-"}`;
    map[i?.id] = nombre;
  }
  return map;
};

export const exportEstadisticasToXLSX = ({
  filteredData,
  resumen,
  fileName = "estadisticas.xlsx",
  meta = {},
}) => {
  const nameById = buildInmuebleNameLookup(filteredData?.inmuebles);

  const resumenAOA = [
    ["Métrica", "Valor"],
    ["Total de inmuebles", resumen.totalInmuebles],
    ["Total de gastos", resumen.totalGastos],
    ["Inmuebles rentados / no rentados", `${resumen.rentedCount} / ${resumen.notRentedCount}`],
    ["Hipotecados / no hipotecados", `${resumen.mortgagedCount} / ${resumen.notMortgagedCount}`],
    ["Total mantenimiento", resumen.totalMantenimiento],
    ["Total de rentas esperado", resumen.totalRentas],
    ["Rentas cobradas (ctd | total)", `${resumen.rentasCobradas.count} | ${resumen.rentasCobradas.total}`],
    ["Rentas atrasadas (ctd | total)", `${resumen.rentasAtrasadas.count} | ${resumen.rentasAtrasadas.total}`],
    ["Rentas programadas (ctd | total)", `${resumen.rentasProgramadas.count} | ${resumen.rentasProgramadas.total}`],
  ];

  const metaEntries = Object.entries(meta || {});
  if (metaEntries.length) {
    resumenAOA.push([]);
    resumenAOA.push(["Filtro", "Valor"]);
    metaEntries.forEach(([k, v]) => {
      resumenAOA.push([k, String(v ?? "-")]);
    });
  }

  const wsResumen = XLSX.utils.aoa_to_sheet(resumenAOA);

  const wsInmuebles = XLSX.utils.json_to_sheet(
    (filteredData.inmuebles || []).map((i) => ({
      nombre: i.name || i.title || `Inmueble #${i.id}`,
      tipo: i.type ?? "-",
      inmobiliaria: getInmobiliaria(i.real_estate) ?? "-",
      rentado: i.isRented ? "Rentado" : "Disponible",
      hipotecado: i.isMortgaged ? "Hipotecado" : "Sin hipoteca",
    }))
  );

  const wsGastos = XLSX.utils.json_to_sheet(
    (filteredData.gastos || []).map((g) => ({
      inmueble: nameById[g.propertieId] || `#${g.propertieId ?? "-"}`,
      concepto: g.name || "-",
      fecha: g.date || "",
      total: Number(g.amount ?? 0) || 0,
    }))
  );

  const wsManto = XLSX.utils.json_to_sheet(
    (filteredData.mantenimiento || []).map((m) => ({
      inmueble: nameById[m.propertieId] || `#${m.propertieId ?? "-"}`,
      servicio: m.description || "-",
      fecha_servicio: m.date_service || "",
      total: Number(m.cost ?? 0) || 0,
    }))
  );

  const wsRentas = XLSX.utils.json_to_sheet(
    (filteredData.edosCta || []).map((r) => ({
      inmueble: nameById[r.propertieId] || `#${r.propertieId ?? "-"}`,
      rango_mes: r.month || "",
      subtotal: Number(r.subtotal ?? 0) || 0,
      iva: Number(r.iva ?? 0) || 0,
      total: Number(r.total ?? 0) || 0,
      clasificacion: clasificarRenta(r),
    }))
  );

  wsResumen["!cols"]   = [{ wch: 28 }, { wch: 30 }];
  wsInmuebles["!cols"] = [{ wch: 30 }, { wch: 16 }, { wch: 22 }, { wch: 14 }, { wch: 16 }];
  wsGastos["!cols"]    = [{ wch: 30 }, { wch: 26 }, { wch: 14 }, { wch: 16 }];
  wsManto["!cols"]     = [{ wch: 30 }, { wch: 28 }, { wch: 18 }, { wch: 16 }];
  wsRentas["!cols"]    = [{ wch: 30 }, { wch: 28 }, { wch: 14 }, { wch: 10 }, { wch: 16 }, { wch: 16 }];

  const wb = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(wb, wsResumen, "Resumen");
  XLSX.utils.book_append_sheet(wb, wsInmuebles, "Inmuebles");
  XLSX.utils.book_append_sheet(wb, wsGastos, "Gastos");
  XLSX.utils.book_append_sheet(wb, wsManto, "Mantenimiento");
  XLSX.utils.book_append_sheet(wb, wsRentas, "Rentas");

  XLSX.writeFile(wb, fileName);
};
